import { IUser } from 'src/types';
import { fetch } from '../fetchWrapper/fetch';
import { API_URL } from 'src/constants';

export interface GetUsersResponse {
  data: IUser[];
  paging?: {
    after?: string;
    before?: string;
  };
}

export const getUsers = async (
  afterCursor?: string,
  beforeCursor?: string,
): Promise<GetUsersResponse> => {
  const params = new URLSearchParams();
  if (afterCursor) {
    params.append('after', afterCursor);
  }
  if (beforeCursor) {
    params.append('before', beforeCursor);
  }

  const queryString = params.toString();
  const uri = queryString ? `${API_URL}/admin/users?${queryString}` : `${API_URL}/admin/users`;

  const response = await fetch(uri);
  if (!response.ok) {
    throw new Error('Could not fetch users');
  }
  const responseBody = await response.json();
  return responseBody;
};
